/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import styled, { css } from 'styled-components';

export const FilterContainer = styled.div`
  border: 1px solid #ccc;

  // CSS transition
  &.dc-filter-container-enter-active {
    transform: translateX(0);
  }
  &.dc-filter-container-enter-done {
    transform: translateX(0);
  }

  &[data-is-loading='true'] {
    overflow: hidden;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    @media only screen and (min-width: 1025px) {
      border: 0;
    }
  }

  @media only screen and (max-width: 1024px) {
    border: 0;
    position: fixed;
    height: 100%;
    z-index: 1000;
    top: 0;
    left: 0;
    padding: 0;
    max-width: 355px;
    width: 355px;
    background-color: #ffffff;
    overflow-y: scroll;
    transform: translateX(-105%);
    transition: transform 0.5s ease-out;
  }

  @media only screen and (max-width: 599px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const FilterContainerLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: white;
  opacity: 0.85;
  pointer-events: none;

  @media only screen and (max-width: 599px) {
    min-width: 100%;
    width: 100%;
  }

  @media only screen and (max-width: 1024px) {
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 355px;
    width: 355px;
  }

  @media only screen and (min-width: 1025px) {
    z-index: 3;
    position: absolute;
  }

  & .dc-icon {
    width: 40px;
    height: 40px;
  }
`;

export const BoldFilterHeader = styled.span``;

export const FilterContainerHeader = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 19px 10px;
  align-items: center;

  h1 {
    font-size: 14px;
    padding: 0 !important;
    margin-bottom: 0;
  }

  @media only screen and (max-width: 1024px) {
    color: #666;
    font-size: 14px;
    font-weight: normal;
    display: block;
    margin-bottom: 0;
    line-height: 50px;
    padding: 3px 18px 0;
    text-overflow: ellipsis;

    ${BoldFilterHeader} {
      font-weight: bold;
      color: #222;
      font-size: 16px;
    }
  }
`;

export const ActiveFiltersTitle = styled.span`
  @media only screen and (max-width: 1024px) {
    font-size: 16px;
  }
`;

export const FilterOverlay = styled.div`
  border: 0;
  position: fixed;
  z-index: 900;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0;
  background-color: #343434;
  opacity: 0;
  display: none;

  // React <CSSTransition> classes
  &.dc-filter-overlay-enter-active {
    display: block;
    opacity: 0.3;
  }
  &.dc-filter-overlay-enter-done {
    display: block;
    opacity: 0.6;
    transition: opacity 200ms;
  }
  &.dc-filter-overlay-exit-active {
    display: block;
    opacity: 0.3;
    transition: opacity 200ms;
  }
  &.dc-filter-overlay-exit-done {
    display: none;
    opacity: 0;
  }
`;

// selected, closed
export const FilterLP = styled.nav`
  margin: 0 0 10px 0;
  padding-left: 10px;
  padding-right: 10px;
  border-top: 1px solid #ccc;

  ${(props) =>
    props.closed
      ? css`
          margin-bottom: 0 !important;
          padding-bottom: 0 !important;
        `
      : ''}

  @media only screen and (max-width: 1024px) {
    padding-left: 0;
    padding-right: 0;
    margin: 0 18px;

    &:only-child {
      margin: 0;
      padding-left: 0;
      padding-right: 0;
      border-top: 0;
    }

    ${(props) =>
      props.selected
        ? css`
            border: 0;
            padding: 0;
            margin: 0;
            &:first-child {
              border-top: 0;
            }
          `
        : ''}

    ${(props) =>
      props.closed
        ? css`
            &:last-child {
              border-bottom: 1px solid #ccc;
            }
          `
        : ''}
  }
`;

export const FilterContainerBody = styled.div`
  @media only screen and (max-width: 1024px) {
    padding: 0;
  }
`;

export const FilterHeader = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin: 0;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 1em;

  .dc-icon {
    min-width: 28px;
  }
`;

export const FilterHeaderClosed = styled.span`
  @media only screen and (min-width: 1025px) {
    flex: 1;
  }
`;

export const FilterHeaderSelectedOptions = styled.span`
  @media only screen and (max-width: 1024px) {
    margin-left: 8px;
    font-size: 12px;
    color: #999;
    font-weight: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    flex: 1;
  }
`;

export const FilterBottomButtons = styled.div`
  background: #fff;
  display: flex;
  z-index: 2;
  justify-content: space-between;
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  bottom: 0;
  box-shadow: 0 -2px 6px 0px rgba(0, 0, 0, 0.1);

  &:nth-child(2) {
    padding-left: 0;
  }

  .dc-button-wrapper {
    display: block;
    padding: 15px 18px;
    width: 100%;
  }

  .dc-button-wrapper button {
    padding: 12px;
  }
`;

export const BottomButtonsWarning = styled.span`
  @media only screen and (max-width: 1024px) {
    color: #c90404;
    background: #ffefef;
    border: 1px solid #c90404;
    display: block;
    position: -webkit-sticky;
    position: sticky;
    margin: 0 18px;
    bottom: 60px;
    text-align: center;
    padding: 12px 0 15px;
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 300ms, opacity 300ms;
  }
`;

export const SelectedHeader = styled.h3`
  @media only screen and (max-width: 1024px) {
    margin: 0 18px;
    color: #666;
    font-size: 14px;
    font-weight: normal;
    display: block;
    margin-bottom: 0;
    line-height: 50px;
    padding: 3px 0 0;
    text-overflow: ellipsis;
    white-space: pre;
    overflow: hidden;

    .dc-icon {
      color: #333;
      margin-top: 0;
    }
  }
`;

export const SelectedHeaderBold = styled.span`
  @media only screen and (max-width: 1024px) {
    color: #222;
    padding-right: 6px;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const OptionList = styled.ul`
  list-style: none;

  @media only screen and (max-width: 1024px) {
    margin: 0 18px;
    border-bottom: 1px solid #ccc;
  }
`;

export const PriceRange = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  @media only screen and (max-width: 1024px) {
    margin: 0 18px;
    justify-content: flex-start;
    padding: 10px 0;
    border-bottom: 1px solid #ccc;
  }
`;

export const PriceRangeCurrency = styled.span`
  width: 1%;
  margin-right: 10px;
`;

export const PriceRangeInputs = styled.div`
  display: flex;
  margin-right: 10px;
  justify-content: space-around;
  width: 71%;
  @media only screen and (max-width: 1024px) {
    justify-content: flex-start;
  }
`;

export const PriceRangeFirstInput = styled.div`
  @media only screen and (max-width: 1024px) {
    margin-right: 20%;
    max-width: 30%;
  }
`;

export const PriceRangeSecondInput = styled.div`
  @media only screen and (max-width: 1024px) {
    max-width: 30%;
  }
`;

export const PriceRangeButton = styled.div`
  width: 30%;
  @media only screen and (max-width: 1024px) {
  }
`;
